import React, { useState, useEffect } from 'react';


export default function Laoding(props) {

  useEffect(() => {
  }, []);

  return (
    <table><tbody>
        <tr><td style={{textAlign:"center"}}><img src={require('../lib/images/loading.gif')} style={{width:"48px", border:"0px solid #b0b0b0"}} /></td></tr>
        {(props.showLable === false)?<></>:<tr><td>{props.label}</td></tr>}
    </tbody></table>                                

  )
}
